import { useEffect, useMemo, useState } from "react";

export default function VehicleImage({ src, alt = "", className = "", fallbackSrc = "", placeholderLabel = "Vehicle photo loading" }) {
  const sources = useMemo(
    () => [src, fallbackSrc].map((value) => String(value || "").trim()).filter(Boolean),
    [fallbackSrc, src],
  );
  const [sourceIndex, setSourceIndex] = useState(0);
  const activeSrc = sources[sourceIndex] || "";
  const [status, setStatus] = useState(activeSrc ? "loading" : "empty");

  useEffect(() => {
    setSourceIndex(0);
    setStatus(sources.length ? "loading" : "empty");
  }, [sources]);

  useEffect(() => {
    setStatus(activeSrc ? "loading" : "empty");
  }, [activeSrc]);

  const showPlaceholder = status !== "loaded";

  return (
    <span className={`vehicle-image-frame${className ? ` ${className}` : ""}${showPlaceholder ? " is-placeholder-visible" : ""}`}>
      {activeSrc ? (
        <img
          src={activeSrc}
          alt={alt}
          onLoad={() => setStatus("loaded")}
          onError={() => {
            if (sourceIndex < sources.length - 1) {
              setSourceIndex((current) => current + 1);
              return;
            }
            setStatus("error");
          }}
        />
      ) : null}
      {showPlaceholder ? (
        <span className="vehicle-image-placeholder" aria-label={placeholderLabel} role="img">
          <i className="ti ti-car" />
        </span>
      ) : null}
    </span>
  );
}
